import React from 'react';
import { useAtom } from 'jotai';
import { darkModeAtom } from '../App';
import { Link } from "react-router-dom";

import error1 from '../assets/img/404-2.png';
import error2 from '../assets/img/404-1.png';
import errordark1 from '../assets/img/404-dark-2.png';
import errordark2 from '../assets/img/404-dark-1.png';

export default function Error() {
    const [darkMode] = useAtom(darkModeAtom);

    return (
        <>
            <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 px-4 py-24 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28 gap-16">
                <div className="xl:pt-24 w-full xl:w-1/2 relative pb-12 lg:pb-0">
                    <div className="relative">
                        <div className="absolute">
                            <div>
                                <h1 className="my-2 font-bold text-2xl">
                                    On dirait que vous vous êtes perdu !
                                </h1>
                                <p className="my-2">Revenez à la page d'accueil pour continuer de naviguer sur notre librairie. ;) </p>
                                <Link to="/" alt="Vers la page d'accueil">
                                    <button className="sm:w-full lg:w-auto my-2 border rounded-2xl md py-4 px-8 text-white text-center bg-blue-900 border-blue-900 hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-indigo-700 focus:ring-opacity-50">C'est parti !</button>
                                </Link>
                            </div>
                        </div>
                        <div>
                            <img src={darkMode ? errordark1 : error1} alt="Erreur 404" />
                        </div>
                    </div>
                </div>
                <div>
                    <img src={darkMode ? errordark2 : error2} alt="Erreur, mauvaise page" />
                </div>
            </div>
        </>
    )
}